import React from "react";

const TemarioDiplomaturaEnfermeriaNeurologica = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Anatomía y evaluación neurológica: rol de enfermería"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Anatomía y fisiología del sistema nervioso central (SNC) y el sistema nervioso periférico (SNP)"}</span></li>
                <li><span className="fw-light">{"Anamnesis de enfermería en neurología"}</span></li>
                <li><span className="fw-light">{"Examen físico neurológico"}</span></li>
                <li><span className="fw-light">{"Estudios complementarios en neurología"}</span></li>
                <li><span className="fw-light">{"Estudios complementarios en neurología"}</span></li>
                <li><span className="fw-light">{"Test de valoración neurológica"}</span></li>
                <li><span className="fw-light">{"Cuidados de enfermería en pacientes neurológicos"}</span></li>
                <li><span className="fw-light">{"Comunicación y apoyo emocional en enfermería neurológica"}</span></li>
                <li><span className="fw-light">{"Actualización científica en enfermería neurológica"}</span></li>
                <li><span className="fw-light">{"Trabajo en equipo y colaboración interprofesional"}</span></li>
            </ul>
            <br /><br />
            <b>{"Paciente con cefalea: valoración e intervenciones de enfermería"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cefalea Tensional"}</span></li>
                <li><span className="fw-light">{"Migraña"}</span></li>
                <li><span className="fw-light">{"Cefalea de Horton"}</span></li>
                <li><span className="fw-light">{"Cefaleas no Vasculares"}</span></li>
                <li><span className="fw-light">{"Anamnesis, Examen Físico y Reconocimiento de Signos y Síntomas Específicos"}</span></li>
                <li><span className="fw-light">{"Estudios Complementarios en el Diagnóstico de Cefaleas"}</span></li>
                <li><span className="fw-light">{"Tratamientos para las Cefaleas"}</span></li>
                <li><span className="fw-light">{"Intervenciones de Enfermería en el Manejo de las Cefaleas"}</span></li>
                <li><span className="fw-light">{"Importancia de la nutrición en el paciente con Cefaleas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Paciente con accidente cerebrovascular: intervenciones de enfermería"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Accidente isquémico transitorio"}</span></li>
                <li><span className="fw-light">{"Accidente cerebrovascular isquémico y hemorrágico"}</span></li>
                <li><span className="fw-light">{"Clasificación"}</span></li>
                <li><span className="fw-light">{"Examen físico"}</span></li>
                <li><span className="fw-light">{"Síndromes"}</span></li>
                <li><span className="fw-light">{"Tratamiento específico"}</span></li>
                <li><span className="fw-light">{"Tiempos para el tratamiento adecuado"}</span></li>
                <li><span className="fw-light">{"Indicaciones y contraindicaciones de trombolisis"}</span></li>
                <li><span className="fw-light">{"Escalas: NIHSS, otras. Trombectomía mecánica indicaciones y contraindicaciones"}</span></li>
                <li><span className="fw-light">{"Cuidados post-trombolisis"}</span></li>
                <li><span className="fw-light">{"Cuidados post-trombectomía"}</span></li>
            </ul>
            <br /><br />
            <b>{"Paciente con traumatismos encéfalocraneanos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fracturas de cráneo"}</span></li>
                <li><span className="fw-light">{"Lesiones cerebrales"}</span></li>
                <li><span className="fw-light">{"Complicaciones hemorrágicas: contusión/hemorragia, hemorragia subaracnoidea, hematoma epidural"}</span></li>
                <li><span className="fw-light">{"Hematoma intraparenquimatoso, hematoma subdural"}</span></li>
                <li><span className="fw-light">{"Otras complicaciones: fístula de LCR, hidrocefalia,"}</span></li>
                <li><span className="fw-light">{"Rol de Enfermería en los TECs"}</span></li>
            </ul>
            <br /><br />
            <b>{"Módulo 5. “liderazgo y psicoeducación al profesional de enfermería, paciente y familia\""}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Aspectos psicológicos del paciente con alteraciones neurológicas y familia"}</span></li>
                <li><span className="fw-light">{"La importancia de la Alfabetización sanitaria. Educación al paciente crónico en su domicilio"}</span></li>
                <li><span className="fw-light">{"Rol de la Enfermera Gestora de Casos orientado al modelo de cuidados humanizados en áreas neurológicas"}</span></li>
                <li><span className="fw-light">{"Autocuidado y gestión emocional de los profesionales de Enfermería de las unidades de neurología"}</span></li>
                <li><span className="fw-light">{"Liderazgo para Enfermería Neurológica"}</span></li>
                <li><span className="fw-light">{"La investigación en la Enfermería Neurológica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Neurología cognitiva: enfermedad de Alzheimer y otras demencias"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Causas de demencia"}</span></li>
                <li><span className="fw-light">{"Tipos de demencia"}</span></li>
                <li><span className="fw-light">{"Anamnesis. Examen físico"}</span></li>
                <li><span className="fw-light">{"Estudios complementarios"}</span></li>
                <li><span className="fw-light">{"Evaluaciones cognitivas"}</span></li>
                <li><span className="fw-light">{"Diagnósticos diferenciales"}</span></li>
                <li><span className="fw-light">{"Síndrome confusional agudo"}</span></li>
                <li><span className="fw-light">{"Rol de Enfermería en el cuidado del paciente con Enfermedades Cognitivas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Cuidados de enfermería al paciente con síndrome de Guillain-Barré y miastenia"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Síndrome de Guillain-Barré: etiología, anamnesis y examen físico"}</span></li>
                <li><span className="fw-light">{"Cuidados del paciente"}</span></li>
                <li><span className="fw-light">{"Mediciones diarias"}</span></li>
                <li><span className="fw-light">{"Tratamiento específico"}</span></li>
                <li><span className="fw-light">{"Evolución"}</span></li>
                <li><span className="fw-light">{"Miastenia Gravis: etiología, anamnesis y examen físico"}</span></li>
                <li><span className="fw-light">{"Cuidados del paciente"}</span></li>
                <li><span className="fw-light">{"Tratamiento específico"}</span></li>
                <li><span className="fw-light">{"Evolución y estadio final"}</span></li>
            </ul>
            <br /><br />
            <b>{"Rol de enfermería en las emergencias neurológicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"ACV, convulsiones, Hemorragia Subaracnoidea, Cefaleas"}</span></li>
                <li><span className="fw-light">{"Cuidados, terapéutica y examen físico"}</span></li>
            </ul>
            <br /><br />
            <b>{"Cuidados neurocríticos y neuroquirúrgicos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cuidados al paciente en coma"}</span></li>
                <li><span className="fw-light">{"Cuidados de Enfermería al paciente en postoperatorio: Columna, Lesiones Cerebrales, entre otras"}</span></li>
                <li><span className="fw-light">{"Hematoma Subdural, Hematoma Epidural, Hemorragia Subaracnoidea. Intervenciones de Enfermería"}</span></li>
                <li><span className="fw-light">{"Presión intracraneana. Síndrome de hipertensión endocraneana. Cuidados de Enfermería"}</span></li>
                <li><span className="fw-light">{"Catéter de Derivación Ventricular externa, PIC. BIS"}</span></li>
            </ul>
            <br /><br />
            <b>{"Convulsiones y cuidados de enfermería"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Convulsiones, tipos y su clasificación"}</span></li>
                <li><span className="fw-light">{"Diagnóstico"}</span></li>
                <li><span className="fw-light">{"Epilepsia"}</span></li>
                <li><span className="fw-light">{"Estudios complementarios"}</span></li>
                <li><span className="fw-light">{"Terapéutica específica"}</span></li>
                <li><span className="fw-light">{"Status convulsivo y su tratamiento"}</span></li>
                <li><span className="fw-light">{"Intervenciones de Enfermería en el paciente con Convulsiones"}</span></li>
            </ul>
            <br /><br />
            <b>{"Rol de enfermería en el cuidado del paciente neurológico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Identificar estado neurológico del paciente"}</span></li>
                <li><span className="fw-light">{"Acciones de prevención: Angulación de cama 30&ordm;, rotación de decúbitos, uso de colchones antiescaras, entre otros"}</span></li>
                <li><span className="fw-light">{"El reconocimiento precoz de signos y síntomas en pacientes neurológicos"}</span></li>
                <li><span className="fw-light">{"Utilización de monitoreo hemodinámico"}</span></li>
                <li><span className="fw-light">{"Valoración pupilar"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaEnfermeriaNeurologica;
